import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { CalendarClock } from "lucide-react";
import {
  ROSTER_MONITORING_LABEL,
  ROSTER_MONITORING_TOOLTIP,
} from "./monitoring-constants";

/** A quiet marker beside the roster's PSV badge. It is emerald, never red:
 * red is reserved for verification findings. */
export function RosterMonitoringIndicator() {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            role="img"
            aria-label={ROSTER_MONITORING_LABEL}
            tabIndex={0}
            className="inline-flex shrink-0 rounded-sm text-emerald-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <CalendarClock className="size-4" aria-hidden="true" />
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-64">
          <span className="font-medium">{ROSTER_MONITORING_LABEL}</span>
          <span className="block text-muted-foreground">
            {ROSTER_MONITORING_TOOLTIP}
          </span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
